'use strict';

module.exports = /[^\u0000-\u0040\u005B-\u0060\u007B-\u007F]+('s)?/g;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/CAPITALIZE_REG.js
// module id = 975
// module chunks = 0